export default { buildTime: '2026-01-20T17:30:43+08:00' }